/**
 * Drafts persistence — saves the current in-progress calculator state to
 * localStorage so it survives the OAuth round-trip (window.location.href).
 *
 * Used when an anonymous user tries to Save/Export → sees the auth prompt →
 * authenticates → comes back to the app. Without this, the form would be
 * empty after the full page reload.
 */
const KEY = "gsce.pendingDraft";

export function saveDraft(payload) {
  try {
    localStorage.setItem(KEY, JSON.stringify({
      ...payload,
      _savedAt: Date.now(),
    }));
  } catch (_) {
    /* localStorage may be unavailable in private mode */
  }
}

export function loadDraft() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    // Drafts expire after 1h to avoid stale state surprises
    if (Date.now() - (data._savedAt || 0) > 60 * 60 * 1000) {
      localStorage.removeItem(KEY);
      return null;
    }
    return data;
  } catch (_) {
    return null;
  }
}

export function clearDraft() {
  try {
    localStorage.removeItem(KEY);
  } catch (_) {}
}
